import {Observable} from "rxjs/Rx";
import {INotificationsCommonWebServiceClient} from "@resources/resources";
import {Injectable} from "@angular/core";
import {Resolve} from "@angular/router";
import {CerbaAuthService, CerbaCookieService, CookieConstantes} from "@digicerba/common";

@Injectable()
export class NotificationNumberResolver implements Resolve<any> {

  constructor(private notificationsWebService: INotificationsCommonWebServiceClient, private cookieService: CerbaCookieService,
              private cerbaAuthService: CerbaAuthService) {
  }

  resolve() {
    let authCookieValue = this.cerbaAuthService.getTokenAuthenticationHeader();
    if (!authCookieValue) {
      authCookieValue = this.cookieService.getCoockieValue(CookieConstantes.COOKIE_AUTH);
    }
    if (authCookieValue) {
      return this.notificationsWebService.countMessageNotifications().catch(() => {
        return Observable.of(0);
      });
    } else {
      return Observable.of(0);
    }
  }
}



// WEBPACK FOOTER //
// /home/vsts/work/1/s/digicerba-modules/digicerba-formulaire-demat/digicerba-formulaire-demat-web/src/angular/cerba/src/app/pages/cerba/notification.resolver.ts